import React from 'react';

export const Anchor = ({ children, link = '', ...props }) => (
  <a href={link} target="_blank" rel="noopener noreferrer" {...props}>
    {children}
  </a>
);

export const AnchorToKakaoCs = ({ children }) => (
  <Anchor link="http://pf.kakao.com/_xokYNK/chat" target="blank">
    {children}
  </Anchor>
);
